import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { BaseDialog, Button, ItemWrapper } from '../../../styles/common/Dialog';

export const Dialog = styled(BaseDialog)`
  width: 600px;
  background-color: ${ColorSF2.lightGray};
  @media (max-height: 530px) {
    max-height: 310px;
  }
`;
export const ContentsBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`;

export const BodyBlock = styled.div``;
export const SubmitBlock = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  @media (max-height: 530px) {
    margin: 10px 0;
  }
`;
export const InfoTitle = styled.div`
  flex: 0 0 120px;
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  align-items: center;
  padding-left: 10px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const InfoBody = styled.div`
  flex: 0 0 460px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  flex-wrap: wrap;
  word-break: break-all;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const InfoBlock = styled(ItemWrapper)`
  margin: 0px 10px;
  @media (max-height: 530px) {
    min-height: 30px;
    font-size: 12px;
  }

  &:last-of-type ${InfoTitle}, &:last-of-type ${InfoBody} {
    border-bottom: none;
  }
`;
export const InputArea = styled.input`
  width: 430px;
  line-height: 20px;
  background-color: ${props => props.isError && '#faa'};
`;
export const DeviceUsers = styled.div`
  width: 100%;
  padding: 5px 10px 5px 0px;
  overflow-y: auto;
  height: 120px;
  @media (max-height: 530px) {
    height: 80px;
  }
`;
export const UserInfo = styled.div`
  flex: 0 0 400px;
  min-height: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-all;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const DefaultUse = styled.div`
  flex: 0 0 105px;
  padding-left: 10px;
  font-size: 12px;
  @media (max-height: 530px) {
    font-size: 10px;
  }
`;
export const UpdateButton = styled(Button)`
  background: ${ColorSF2.navyBlue} 0% 0% no-repeat padding-box;
  color: ${ColorSF2.white};
`;
